import { ChangeDetectorRef, Component, EventEmitter, OnDestroy, OnInit, Output, ViewChild } from '@angular/core';
import { DxFormComponent, DxPopupComponent } from 'devextreme-angular';
import { ConstantsService } from 'src/app/services/constants.service';
import { Client } from '../../model/client.model';
import * as AspNetData from 'devextreme-aspnet-data-nojquery';
import { ClientService } from 'src/app/services/client.service';
import { take } from 'rxjs/operators';
import { SessionContextService } from 'src/app/services/session-context.service';
import { ClientCreditHistoryComponent } from '../client-credit-history/client-credit-history.component';
import * as dayjs from 'dayjs';
import { EventService } from 'src/app/services/event.service';
import { Subscription } from 'rxjs';
import { ClientPhotoComponent } from '../client-photo/client-photo.component';
import { ClientPhotoUploadComponent } from '../client-photo-upload/client-photo-upload.component';
import { AS365FeatureFlags, enumAS365FeatureFlags } from 'src/app/services/default-data.service';
import { alert } from 'devextreme/ui/dialog';
import { Country } from '../../model/country';
import { AsYouType, isValidPhoneNumber, parsePhoneNumberWithError } from 'libphonenumber-js/mobile';

class SessionDelayItem
{
  Value:number=null;
  Text:string='';

  constructor(v:number, t:string) {
    this.Value=v;
    this.Text=t;
  }
}

@Component({
  selector: 'app-client-editor',
  templateUrl: './client-editor.component.html',
  styleUrls: ['./client-editor.component.css']
})
export class ClientEditorComponent implements OnInit, OnDestroy {

  @ViewChild(ClientPhotoUploadComponent) ctlPhoto: ClientPhotoUploadComponent;

  minDateForOnlineBooking = undefined;
  onlineBookingRequireDob = false;
  onlineBookingRequireMobile = false;
  onlineBookingRequireSkinType = false;
  onlineBookingRequirePhoto = false;
  photoUploaded: boolean;
  defaultDataChanged$: Subscription;
  DOBRequired: boolean = false;
  mobileRequired: boolean = false;
  emailRequired: boolean = false;
  skinTypeRequired: boolean = false;
  idCheckRequired: boolean = false;
  minDOB: Date;
  maxDOB: Date;
  dirty: boolean = false;
  isAdmin: boolean = this.session.ctx.Employee.IsAdmin;
  FFClientDiscounts: boolean = this.session.IsFeatureEnabled(enumAS365FeatureFlags.ClientDiscounts) || false;
  selectedTabIndex: number;
  SessionDelayData:SessionDelayItem[] = [];  
  country: Country;
  defaultCountry: Country;
  countries: Country[];
  clientMobileDisplayValue: string = '';

  discountEditorOptions = {
    format: 'fixedPoint',
    min: 0,
    max: 100,
    showSpinButtons: true,
    showClearButton: true,
    readonly: !this.isAdmin,
    disabled: !this.isAdmin,
    mode: 'number',
    onValueChanged: this.DiscountValueChanged.bind(this)
  };
  DiscountValueChanged(e) {
    if (e.value == null || e.value == undefined)
      e.component.option('value', 0);
  }

  constructor(
    public constants: ConstantsService,
    private clientService: ClientService,
    public session: SessionContextService,
    private events: EventService,
    private changeDetectorRef: ChangeDetectorRef,
  ) {
    this.EmailAddressValidation = this.EmailAddressValidation.bind(this);
    this.validateDOBIfRequried = this.validateDOBIfRequried.bind(this);
    this.validateMobileFormat = this.validateMobileFormat.bind(this);
    this.validateMobileIfRequired = this.validateMobileIfRequired.bind(this);
    this.validateEmailFormat = this.validateEmailFormat.bind(this);
    this.validateEmailIfRequired = this.validateEmailIfRequired.bind(this);
    this.validateSkinTypeIfRequired = this.validateSkinTypeIfRequired.bind(this);
    this.onShowing = this.onShowing.bind(this);
    this.onHiding = this.onHiding.bind(this);
    this.showClient = this.showClient.bind(this);
    this.showClientById = this.showClientById.bind(this);

    this.SessionDelayData=[];
    this.SessionDelayData.push(new SessionDelayItem(null,'Use system default'));
    for(var i=1;i<=20;i++)
    {
      this.SessionDelayData.push(new SessionDelayItem(i, i.toString()+' minutes'));
    }

    this.branchLookup = AspNetData.createStore({
      key: 'Value',
      loadUrl: '/api/LookupData/GetBranchLookup?AddAll=0',
      onBeforeSend: (e, ajax) => {
        ConstantsService.AddDefaultHeaders(e, ajax);
      },
    });

    this.skinTypeLookup = AspNetData.createStore({
      key: 'Value',
      loadUrl: '/api/LookupData/GetSkinTypesLookup',
      loadParams: { OnlyActive: ((this.client && this.client.SkinTypeId) ? this.client.SkinTypeId : 0) },
      onBeforeSend: (e, ajax) => {
        ConstantsService.AddDefaultHeaders(e, ajax);
      },
    });

    this.defaultDataChanged$ = this.events.onDefaultDataChanged.subscribe(_ => {
      this.updateSettings();
    });

    this.updateSettings();
  }

  @Output() CloseDlg: EventEmitter<Client> = new EventEmitter<Client>();
  @ViewChild(DxPopupComponent) popup: DxPopupComponent;
  @ViewChild(DxFormComponent) form: DxFormComponent;
  @ViewChild(ClientCreditHistoryComponent) ctlCreditHistory: ClientCreditHistoryComponent;
  @ViewChild(ClientPhotoComponent) dlgClientPhotoDlg: ClientPhotoComponent;

  client: Client = new Client();

  skinTypeLookup: any;
  branchLookup: any;

  SaveButtonOptions = {
    text: 'Save',
    onClick: this.btnSave.bind(this)
  };

  CancelButtonOptions = {
    text: 'Cancel',
    onClick: this.btnCancel.bind(this),
  };

  get disableMobileTelephone(): boolean {
    return !(this.client && this.client.MobileTelephone && this.client.MobileTelephone.length > 0);
  }

  get disableAddress(): boolean {
    return !(this.client && this.client.Address1 && this.client.Address1.length > 0);
  }

  get disableEmailAddress(): boolean {
    return !(this.client && this.client.EmailAddress && this.client.EmailAddress.length > 0);
  }

  get disableHomeTelephone(): boolean {
    return !(this.client && this.client.HomeTelephone && this.client.HomeTelephone.length > 0);
  }

  EmailAddressValidation(params): Promise<boolean> {
    return new Promise((resolve) => {
      this.clientService.ValidateNewUserEmail(params.value, this.client.Id).pipe(take(1)).subscribe((result: any) => {
        resolve(result.Msg && this.client.Id === -1 ? false : true);
      });
    });
  }

  validateDOBIfRequried(e: any): boolean {
    return this.DOBRequired && this.client.Id === -1 ? e.value : true;
  }

  validateMobileFormat(e: any): boolean {
    return e.value.length ? isValidPhoneNumber(e.value, this.country?.ISO2) : true;
  }

  validateMobileIfRequired(e: any): boolean {
    return this.mobileRequired && this.client.Id === -1 ? e.value : true;
  }

  validateEmailFormat(e: any): boolean {
    return e.value.length ? this.constants.EmailPattern.test(e.value) : true
  }

  validateEmailIfRequired(e: any): boolean {
    return this.emailRequired && this.client.Id === -1 ? e.value : true;
  }

  validateSkinTypeIfRequired(e: any): boolean {
    return this.skinTypeRequired && this.client.Id === -1 ? e.value : true;
  }

  updateSettings() {
    const settings = this.session.defaultData.defData.customerSettings;
    const minAge = settings.OnlineReservationMinAge;
    this.minDateForOnlineBooking = dayjs(new Date()).add(-1 * minAge, 'year');
    this.onlineBookingRequireDob = settings.OnlineReservationRequireDob;
    this.onlineBookingRequireMobile = settings.OnlineReservationRequireMobile;
    this.onlineBookingRequireSkinType = settings.OnlineReservationRequireSkinType;
    this.onlineBookingRequirePhoto = settings.OnlineReservationRequirePhoto;
    this.selectedTabIndex = settings.DetailsTabByDefault ? 0 : 1;
    this.countries = this.constants.Countries;
    this.defaultCountry = this.constants.DefaultCountry;
  }

  togglePhotoUploaded(photoUploaded: boolean) {
    this.photoUploaded = photoUploaded
  }

  btnSave() {
    this.dirty = true;
    // validate rest of form
    const v = this.form.instance.validate();
    v.complete.then((res) => {
      console.log('Form', this.form, res);
      if (res.isValid) {
        try {
          this.client.MobileTelephone = parsePhoneNumberWithError(
            this.client.MobileTelephone,
            this.country?.ISO2
          ).formatInternational();
        } catch (err) {
          this.client.MobileTelephone = null;
        }

        // check dob has been specified if required
        if (this.DOBRequired && this.client.Id === -1 && !this.client.DateOfBirth) return;
        // check dob is within allowed range
        if (this.client.DateOfBirth && (dayjs(this.client.DateOfBirth) > dayjs(this.maxDOB))) return;
        if (this.client.DateOfBirth && (dayjs(this.client.DateOfBirth) < dayjs(this.minDOB))) return;

        this.client.photo = this.ctlPhoto.imageSource;
        if (this.ctlPhoto.deleteImage == true)
          this.client.photo = 'delete';

        if ((this.client.IdChecked === true) && (!this.client.IdCheckedDateTime)){
          this.client.IdCheckedDateTime = ConstantsService.MakeDateTimeGMT(new Date());
        }

        // so far so good - process the save
        this.clientService
          .CreateOrUpdateClient(this.client)
          .pipe(take(1))
          .subscribe((r: Client) => {
            this.closePopup(r);
          });
      }
    });
  }

  btnCancel() {
    // Save nothing but set NewOnlineClientWarningConfirmed to true
    if (this.client.Id > 0 && !this.client.NewOnlineClientWarningConfirmed) {
      this.clientService.CreateOrUpdateClient(this.client, 1).pipe(take(1)).subscribe();
    }
    this.closePopup();
  }

  closePopup(client?: Client) {
    this.CloseDlg.emit(client);
    this.ResetForm();
    this.popup.visible = false;
  }

  ngOnInit(): void {
    const d = new Date(); // current date
    this.minDOB = new Date(Date.UTC(d.getFullYear() - 110, 1, 1));  // 110 years ago
    this.maxDOB = new Date(Date.UTC(d.getFullYear(), d.getMonth(), d.getDate())); // current date (UTC)    
  }

  ngOnDestroy(): void {
    if (this.defaultDataChanged$) { this.defaultDataChanged$.unsubscribe(); }
  }

  onShowing(e) {
  }

  onHiding(e) {
  }

  showClientById(ClientId: number, newOnlineClientWarningConfirmed: boolean = false) {    
    if (ClientId > 0) {
      this.clientService
        .GetClient(ClientId)
        .pipe(take(1))
        .subscribe((r) => {
          if (r) {
            this.client = r;
            this.showClient(r, newOnlineClientWarningConfirmed);
          }
        });
    } else {
      this.showClient(null, newOnlineClientWarningConfirmed);
    }
  }

  showClient(client: Client, newOnlineClientWarningConfirmed: boolean = false) {
    if (client != null) {
      this.client = client;

      if (!!client.MobileTelephone) {
        try {
          const phoneNumber = parsePhoneNumberWithError(this.client.MobileTelephone);
          if (phoneNumber.country !== this.country?.ISO2) {
            this.country = this.countries.find(country => {
              return country.ISO2 === phoneNumber.country;
            });
          }
          const format = new AsYouType(this.country?.ISO2);
          this.clientMobileDisplayValue = format
            .input(phoneNumber.number)
            .replace(`+${this.country?.ISD}`, '')
            .replace('+', '')
            .trim();
        } catch {
          this.clientMobileDisplayValue = this.client.MobileTelephone.trim();
          this.country = this.defaultCountry;
        }
      } else {
        this.clientMobileDisplayValue = '';
        this.country = this.defaultCountry;
      }

      this.popup.title =
        'Client : ' + this.client.FirstName + ' ' + this.client.LastName;
      this.clientService
        .GetClientPhotos(this.client.Id)
        .pipe(take(1))
        .subscribe((photo) => {
          this.photoUploaded = photo.length > 0;
        });
    } else {
      this.client = new Client();
      this.client.Id = -1;
      this.popup.title = 'New Client';
      this.client.Active = true;
      this.client.Gender = 'U';
      this.client.BranchEnrolled = this.session.ctx.BranchId;
      this.client.ContactByAddress = false;
      this.client.ContactByEmail = false;
      this.client.ContactByHomeTelephone = false;
      this.client.ContactByMobileTelephone = false;
      this.client.AllowOnlineBooking = true;
      this.client.IdChecked = false;
      this.client.NewOnlineClientWarningConfirmed = true;
      const settings = this.session.defaultData.defData.customerSettings;
      this.DOBRequired = settings.ClientRequireDOB;
      this.mobileRequired = settings.ClientRequireMobile;
      this.emailRequired = settings.ClientRequireEmail;
      this.skinTypeRequired = settings.ClientRequireSkinType;
      this.idCheckRequired = settings.ClientRequireIDCheck;
      this.clientMobileDisplayValue = '';
      this.country = this.defaultCountry;
    }
    this.skinTypeLookup.load();

    if (this.ctlCreditHistory) {
      this.ctlCreditHistory.clientId = this.client.Id || -1;
    }

    if (this.client.AllowOnlineBooking !== false) {
      this.client.AllowOnlineBooking = true;
    }

    if (!newOnlineClientWarningConfirmed && this.client.NewOnlineClientWarningConfirmed === false) {
      alert('This client has registered online, please check their details', 'New Online Client').then((val) => {
        if (val !== null) {
          this.popup.visible = true;
        }
      });
    } else {
      this.popup.visible = true;
    }
  }

  onMobileISDSelected(e: any): void {
    this.country = e.value;
  }

  onMobileInput(e: any): void {
    const format = new AsYouType(this.country?.ISO2);
    const example = new AsYouType(this.country?.ISO2);
    example.input(this.country.exampleNumber);
    const prefix = '+' + example.getCallingCode();
    const max = this.country.maxLength;

    let newVal: string = e.event.target.value.replace(/\D/g, '').trim();

    if (newVal.replace(/\s/g, '').length > max - 1) {
      newVal = newVal.slice(0, newVal.length - (newVal.length - max));
    }

    newVal = format
      .input(prefix + newVal)
      .replace(prefix, '')
      .trim();

    e.event.target.value = newVal;
    this.client.MobileTelephone = newVal;
  }

  ResetForm() {
    this.client = undefined;
    this.dirty = false;
    if (this.ctlCreditHistory) { this.ctlCreditHistory.Reset(); }
  }

  FirstLetterUpperCaseEditorOptions = {
    onKeyUp: this.onKeyUp.bind(this),
    maxLength: 30,
  };

  FirstLetterUpperCaseEditorOptions10 = {
    onKeyUp: this.onKeyUp.bind(this),
    maxLength: 10,
  };

  onKeyUp(e) {
    var s= e.component.option('text');
    s=this.capitalizeWords(s);
    e.component.option('value', s);
  }

  capitalizeWords(str) {    
      var s = str
        .toLowerCase()
        .split(' ')
        .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
        .join(' ');
      return s;    
  }
}
